import axios from "axios";

export const postData = async (url, transactions, config) => {
  const response = await axios.post(url, transactions, config);
  return response;
};
